import React from "react";
import Bilder from "../components/Bilder/Bilder";

function BilderPage() {
  return (
    <div style={{ padding: "40px" }}>
      <Bilder />
    </div>
  );
}

export default BilderPage;